import test_entry_config from "../config/test_entry_config.json";
import { cloneDeep } from "lodash";
import {
  getCumulativeSum,
  getProbabilityPercentOfTheValueFromArray,
  getRingNoOfElement,
} from "../util/TestEntryUtil";

export function getGrayScaleImageForPValue(percentBorders, value) {
  if (value < percentBorders[0]) {
    return 0;
  } else if (value < percentBorders[1]) {
    return 3;
  } else if (value < percentBorders[2]) {
    return 4;
  } else if (value < percentBorders[3]) {
    return 6;
  } else {
    return 8;
  }
}

export default function StatisticsMap(input, eye, testType, middleCol, middleRow, percentageStr) {
  const config = cloneDeep(test_entry_config["thresholdMap"][testType][eye]);
  const statistics = cloneDeep(test_entry_config["statisticsValueBorders"]);

  const elementsInRow = cloneDeep(config["elementsInRow"]);
  const startIndexForElementsInRow = config["startIndexForElementsInRow"];
  const standardDeviations = test_entry_config["standardDeviations"][testType][eye];

  const percentBorders = statistics[percentageStr];

  const cumulativeElementsInRow = getCumulativeSum(elementsInRow);
  cumulativeElementsInRow.unshift(0);

  const ps = [];
  let ind = 0;
  const elementsGs = [];
  const images = [];
  const maxRowLength = Math.max(...elementsInRow);
  for (let i = 0; i < elementsInRow.length; i++) {
    for (let j = 0; j < maxRowLength; j++) {
      const ring = getRingNoOfElement(
        cumulativeElementsInRow,
        middleRow,
        middleCol,
        cumulativeElementsInRow,
        ind,
        startIndexForElementsInRow,
      );
      //console.log("ring:" + ring + " ind:" + ind);

      if (elementsInRow[i] > 0 && j >= startIndexForElementsInRow[i]) {
        elementsInRow[i]--;
        let p = getProbabilityPercentOfTheValueFromArray(
          input,
          ind,
          standardDeviations,
          percentageStr,
        );
        // console.log("ring:" + ring + " p:" + p, " r:" + ring * p);
        p = ring > 1 ? ring * 2 * p : p;
        ps.push(p);
        images.push(getGrayScaleImageForPValue(percentBorders, p));

        ind++;
      }
    }
  }
  return { elementsGs, ps, images };
}
